export default {
  methods: {
    DLPSectionView(section) {
      const wrapperHeight = this.UserAgent.window.width > 1024 ? 50 : 38;
      const mobileIsiHeight = this.UserAgent.window.width > 1024 ? 0 : 251;
      const mobilePanelHeight = this.UserAgent.window.width > 1024 ? 0 : 54;
      return { // returned object will be argument to v-onviewport directive
        handlerIn: () => {
          dataLayer.push({ 'event': 'section-view', 'section': section, 'subsection': '-'});
        },
        viewportTriggerTop: wrapperHeight + mobilePanelHeight,
        viewportTriggerBottom: -(wrapperHeight + mobileIsiHeight),
      }
    },
    DLPSectionClick(section) {
      dataLayer.push({ 'event': 'section-click', 'section': section, 'subsection': '-'});
    },
    DLPButtonClick(button) {
      dataLayer.push({ 'event': 'button-click','page-name': 'homepage','button-name': button});
    }
  }
}
